import { UserModel } from '../../models/user/user.model';
import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { ChronoVersionEnum } from '../../models/client-models';

const DEFAULT_REDIRECT_URL = '/badge';

export interface SessionState {
  successful: boolean;
  pending: boolean;
  user: UserModel;
  chronoVersion: ChronoVersionEnum;
  deviceName: string;
  redirectUrl: string;
  uuid: string;
  showPersonalList: boolean;
  nativeDevice: boolean;
  menuToggle: boolean;
  settingsUpdated: boolean;
  showSplash2Sek: boolean;
  visumWithTime: boolean;
  navigateToDefaultUrl: boolean;
}

export const createInitialState = (): SessionState => ({
  successful: false,
  pending: false,
  user: {} as UserModel,
  deviceName: '',
  redirectUrl: DEFAULT_REDIRECT_URL,
  uuid: '',
  chronoVersion: ChronoVersionEnum.Standard,
  showPersonalList: true,
  nativeDevice: false,
  menuToggle: true,
  settingsUpdated: false,
  showSplash2Sek: false,
  visumWithTime: false,
  navigateToDefaultUrl: false
});

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'session' })
export class SessionStore extends Store<SessionState> {
  constructor() {
    super(createInitialState());
  }
}
